interface OwnedRecorderStatus { owner?: string; ownerLockId?: string }
/** Bind only the owner which is still active after asynchronous native reads.
 * A fresh native lock token invalidates every bind started before logout. */
export async function readBoundRecorderStatus<T extends OwnedRecorderStatus>(actor: string, adapter: {
  currentOwner(): string | null;
  status(): Promise<T>;
  bind(lockId: string): Promise<T>;
  leave(): Promise<unknown>;
}): Promise<T> {
  const assertCurrent = () => { if (adapter.currentOwner() !== actor) throw new Error('TRAVEL_SESSION_CONFLICT'); };
  assertCurrent(); const current = await adapter.status(); assertCurrent();
  if (current.owner && current.owner !== actor) throw new Error('TRAVEL_SESSION_CONFLICT');
  if (!current.ownerLockId) return current;
  const bound = await adapter.bind(current.ownerLockId);
  if (adapter.currentOwner() !== actor) {
    // A leave racing the bind remains locked, regardless of bridge delivery order.
    await adapter.leave().catch(() => undefined);
    throw new Error('TRAVEL_SESSION_CONFLICT');
  }
  if (bound.owner && bound.owner !== actor || bound.ownerLockId) throw new Error('TRAVEL_SESSION_CONFLICT');
  return bound;
}
